/**
 * Indian Rupee & Localization Utilities for Asset Management System
 */

/**
 * Format an amount into Indian Rupee format (e.g. ₹1,50,000 or ₹1.50 Lakh / ₹1.25 Cr)
 * @param {number|string} amount
 * @param {boolean} compact
 * @returns {string}
 */
export const formatINR = (amount, compact = false) => {
  const val = Number(amount) || 0;

  if (compact) {
    const absVal = Math.abs(val);
    const sign = val < 0 ? '-' : '';

    if (absVal >= 10000000) {
      // Crores (1 Cr = 10,000,000)
      return `${sign}₹${(absVal / 10000000).toFixed(2)} Cr`;
    }
    if (absVal >= 100000) {
      // Lakhs (1 Lakh = 100,000)
      return `${sign}₹${(absVal / 100000).toFixed(2)} Lakh`;
    }
    if (absVal >= 1000) {
      // Thousands
      return `${sign}₹${(absVal / 1000).toFixed(1)} K`;
    }
    return `${sign}₹${Math.round(absVal).toLocaleString('en-IN')}`;
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(val);
};

/**
 * Format a number using the Indian numbering system (e.g. 1,50,000)
 * @param {number|string} num
 * @returns {string}
 */
export const formatIndianNumber = (num) => {
  const val = Number(num) || 0;
  return new Intl.NumberFormat('en-IN').format(val);
};

/**
 * Format a date in Indian format (DD/MM/YYYY or DD MMM YYYY)
 * @param {string|Date} date
 * @param {boolean} withTime
 * @returns {string}
 */
export const formatIndianDate = (date, withTime = false) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  if (isNaN(d.getTime())) return String(date);

  if (withTime) {
    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

